const storefronts = {
  urls: {
    production: 'https://brooklinen2.myshopify.com/api/graphql.json',
    development: 'https://brooklinen2-dev.myshopify.com/api/graphql.json',
  },
  tokens: {
    production: '1df3208eb91e08917630edfd363ed609',
    development: '7dbd10f65cf1df371c3b20041291c506',
  },
};

export function clean(input) {
  if (!input) return null;
  const output = {};
  const isObject = (obj) => {
    return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
  };

  Object.keys(input).forEach((key) => {
    if (input[key] && input[key].edges) {
      output[key] = input[key].edges.map((edge) => clean(edge.node));
    } else if (isObject(input[key])) {
      output[key] = clean(input[key]);
    } else if (key !== '__typename') {
      output[key] = input[key];
    }
  });

  return output;
}

const gqlHeaders = () => {
  const accessToken = storefronts.tokens[window.Brooklinen.mode];
  return {
    'Content-Type': 'application/graphql',
    'X-Shopify-Storefront-Access-Token': accessToken,
  };
};

const jsonHeaders = () => {
  const accessToken = storefronts.tokens[window.Brooklinen.mode];
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Shopify-Storefront-Access-Token': accessToken,
  };
};

const options = (query, headers) => {
  return {
    method: 'post',
    headers: headers,
    body: query,
  };
};

// Set up headers, options, and make the request.
export const fetchStorefront = async (query) => {
  const hasVariables = typeof query === 'object';
  const headers = hasVariables ? jsonHeaders() : gqlHeaders();
  const data = hasVariables ? JSON.stringify(query) : query;
  const storefront = storefronts.urls[window.Brooklinen.mode];

  const response = await fetch(storefront, options(data, headers)).then((res) => res.json());

  return response;
};
